import { User } from '../models/User';
import { getUserScopedStorageKeys } from '../storage/UserScopedStorageKeys';

class UserDAO {
  static getUser(): User | null {
    const key = getUserScopedStorageKeys().USER_KEY;
    // Check localStorage first (Remember Me), then sessionStorage (session-only)
    const localStr = localStorage.getItem(key);
    if (localStr) return JSON.parse(localStr);
    const sessionStr = sessionStorage.getItem(key);
    return sessionStr ? JSON.parse(sessionStr) : null;
  }

  static setUser(user: User, remember: boolean): void {
    const key = getUserScopedStorageKeys().USER_KEY;
    if (remember) {
      localStorage.setItem(key, JSON.stringify(user));
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, JSON.stringify(user));
      localStorage.removeItem(key);
    }
  }

  static clear(): void {
    const key = getUserScopedStorageKeys().USER_KEY;
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }
}

export default UserDAO;
